<template>
  <div>
    <article
      v-if="!isLoading"
      class="card"
    >
      <header class="text-center py-3">
        <h1
          class="text-grey-darkest text-lg1"
          v-text="managedPage.attributes.title"
        />
        <CommPopper ref="comPopper">
          <div
            slot="content"
            class="flex flex-col"
          >
            <a
              :href="editUrl"
              v-text="'Edit'"
            />
            <a
              v-if="managedPage.attributes.is_disabled"
              @click.prevent="openEnableModal"
              v-text="'Enable'"
            />
            <a
              v-else
              @click.prevent="openDisableModal"
              v-text="'Disable'"
            />
            <a
              @click.prevent="openDeleteModal"
              v-text="'Delete'"
            />
          </div>
        </CommPopper>
      </header>
      <div
        v-if="managedPage.attributes.icon"
        class="mb-8 card-header-image"
      >
        <img
          :src="managedPage.attributes.icon"
          alt=""
        >
      </div>
      <div class="card-content mx-auto">
        <BaseHtmlContainer :content="managedPage.attributes.content" />
      </div>
      <div class="text-center mb-3">
        <a
          href="javascript:history.back()"
          class="btn"
          v-text="'Back'"
        />
      </div>
      <DeleteManagedPageModal
        :show="showDeleteModal"
        :managed-page="managedPage"
        @destroyed="redirect('managed-pages')"
        @close="showDeleteModal = false"
      />
      <DisableManagedPageModal
        :show="showDisableModal"
        :managed-page="managedPage"
        @disabled="redirect('managed-pages')"
        @close="showDisableModal = false"
      />
      <EnableManagedPageModal
        :show="showEnableModal"
        :managed-page="managedPage"
        @enabled="redirect('managed-pages')"
        @close="showEnableModal = false"
      />
    </article>
  </div>
</template>

<script type="text/babel">
import CommPopper from 'Communication/Resources/assets/js/components/CommPopper'
import BaseHtmlContainer from 'Base/Resources/assets/js/components/BaseHtmlContainer'
import DeleteManagedPageModal from './modals/DeleteManagedPageModal'
import DisableManagedPageModal from './modals/DisableManagedPageModal'
import EnableManagedPageModal from './modals/EnableManagedPageModal'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ManagedPage',
  components: {
    CommPopper,
    DeleteManagedPageModal,
    DisableManagedPageModal,
    EnableManagedPageModal,
    BaseHtmlContainer,
  },
  props: {
    managedPageUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      showDeleteModal: false,
      showDisableModal: false,
      showEnableModal: false,
    }
  },
  computed: {
    ...mapState({
      managedPage: state => state.managedPage.managedPage,
    }),
    editUrl(){
      return this.$urlGenerator.active(`managed-pages/${this.managedPageUuid}/edit`)
    },
  },
  mounted() {
    this.getManagedPage(this.managedPageUuid).then(() => {
      this.isLoading = false
    })
  },
  methods: {
    ...mapActions({
      getManagedPage: 'managedPageGetManagedPage',
    }),
    hidePopper() {
      this.$refs.comPopper.close()
    },
    redirect(to) {
      window.location.replace(this.$urlGenerator.active(to))
    },
    openDeleteModal() {
      this.showDeleteModal = true

      this.hidePopper()
    },
    openDisableModal() {
      this.showDisableModal = true

      this.hidePopper()
    },
    openEnableModal() {
      this.showEnableModal = true

      this.hidePopper()
    },
  },
}
</script>